import React from 'react';

// Create a context with a default value of true (drawer open)
export const DrawerContext = React.createContext<boolean>(true);
